import React from "react";
import Container from "react-bootstrap/Container";

function AGB() {
  return (
    <div className="hero-container">
      <Container
        className="py-5"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          borderRadius: "10px",
          color: "black",
        }}
      >
        <h1 className="text-center mb-4">Allgemeine Geschäftsbedingungen (AGB)</h1>

        <p>
          Willkommen bei Grüne Wege GmbH. Durch die Nutzung unserer Dienste
          erklären Sie sich mit den folgenden Allgemeinen Geschäftsbedingungen
          (AGB) einverstanden. Bitte lesen Sie diese sorgfältig durch.
        </p>

        <h3>1. Geltungsbereich</h3>
        <p>
          Diese AGB gelten für alle Verträge zwischen der Grüne Wege GmbH und
          unseren Kunden, die über unsere Website oder auf anderem Wege
          abgeschlossen werden.
        </p>

        <h3>2. Vertragsschluss</h3>
        <p>
          Ein Vertrag kommt zustande, wenn der Kunde unser Angebot über unsere
          Website akzeptiert oder wenn ein Angebot von uns schriftlich oder
          mündlich bestätigt wird.
        </p>

        <h3>3. Preise und Zahlung</h3>
        <p>
          Alle auf unserer Website angegebenen Preise verstehen sich inklusive
          der gesetzlichen Mehrwertsteuer. Zahlungen sind per Überweisung,
          Kreditkarte oder PayPal möglich.
        </p>

        <h3>4. Lieferung</h3>
        <p>
          Die Lieferung erfolgt, sofern nicht anders vereinbart, an die vom
          Kunden angegebene Lieferadresse. Die Lieferzeiten können je nach
          Produkt und Verfügbarkeit variieren.
        </p>

        <h3>5. Widerrufsrecht</h3>
        <p>
          Verbraucher haben das Recht, den Vertrag innerhalb von 14 Tagen ohne
          Angabe von Gründen zu widerrufen. Weitere Details zum Widerrufsrecht
          finden Sie in unserer Widerrufsbelehrung.
        </p>

        <h3>6. Haftung</h3>
        <p>
          Wir haften nur für Schäden, die durch vorsätzliches oder grob
          fahrlässiges Verhalten verursacht wurden. Eine Haftung für
          Folgeschäden ist ausgeschlossen.
        </p>

        <h3>7. Datenschutz</h3>
        <p>
          Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Weitere
          Informationen finden Sie in unserer Datenschutzerklärung.
        </p>

        <h3>8. Schlussbestimmungen</h3>
        <p>
          Es gilt das Recht der Bundesrepublik Deutschland. Sollte eine Bestimmung
          dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen
          unberührt.
        </p>

        <h3>9. Kontakt</h3>
        <p>
          Wenn Sie Fragen zu diesen AGB haben, können Sie uns jederzeit
          kontaktieren:
        </p>
        <p>
          Grüne Wege GmbH<br />
          Musterstraße 123<br />
          12345 Musterstadt<br />
          Telefon: +49 123 456 789<br />
          E-Mail: agbs@gruenewege.de
        </p>

        <p>
          Diese AGB werden regelmäßig aktualisiert, um den rechtlichen Anforderungen
          zu entsprechen.
        </p>
      </Container>
    </div>
  );
}

export default AGB;
